<app-journey-list-template-checkbox
        *ngIf="task.task" class="blue"
        [task]="task"></app-journey-list-template-checkbox>

<div class="text">
    <div *ngIf="!task.task" class="title my-color-blue" [innerHTML]="(for_manager ? task.title_for_manager ?? task.title : task.title) | safeHtml"></div>
</div>

<div class="feedback-list">
    <ng-container  *ngFor="let question of task.details.custom_feedback.answers; let i = index;">
    <div class="item swiper-no-swiping"
         *ngIf="question.question.is_visible || question.value"
         [ngClass]="{'selected': question.value, 'disabled': !question.question.is_active || disabled}"
         (click)="onChange(question)"
    >
        <div class="content">
            <div class="text">
                {{question.question.title}}
            </div>
        </div>
    </div>
    </ng-container>
</div>
